module.exports = __webpack_public_path__ + "img/3600.17360b90.jpg";